import React from 'react';
import {
  CheckboxContainer,
  HiddenInput,
  StyledCheckbox,
  Checkmark,
} from 'src/components/Input/CheckboxInput/CheckboxInput.style';
import { ICheckbox } from 'src/components/Input/CheckboxInput/CheckboxInput.i';

export const Checkbox = ({ checked, ...props }: ICheckbox) => (
  <CheckboxContainer>
    <HiddenInput type='checkbox' checked={checked} {...props} />
    <StyledCheckbox checked={checked}>
      <Checkmark viewBox='0 0 24 24'>
        <polyline points='20 6 9 17 4 12' />
      </Checkmark>
    </StyledCheckbox>
  </CheckboxContainer>
);
